<template>
  <div class="shared-hotel-adv">
    <nav-bar fontColor="#333" @goBack="goBack" :titleText="$route.query.main_title" fontSize="18px"></nav-bar>
    <img :src="$route.query.img_url" alt="">
  </div>
</template>

<script>
import navBar from './components/navBar'
export default {
  data() {
    return {
      // href: this.$route.query.href
    }
  },
  components:{
    navBar
  },
  created() {
  },
  
  mounted() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
  }
};
</script>

<style lang="less">
.shared-hotel-adv {
  padding-top: 88px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
